import { generatePath } from 'react-router';

import { AppRoutes } from '@/screens/AppRoutes';

export function getActionLink(actionId: string): string {
  if (actionId) {
    return generatePath(AppRoutes.RoadmapAction, {
      actionId,
    });
  } else {
    return generatePath(AppRoutes.Roadmap);
  }
}
